import React from 'react'
import { NavLink, Route, Switch } from 'react-router-dom'
import { NavTabs } from '@abroad/components'
import CompletedSessions from './CompletedSessions'
import UpcomingSessions from './UpcomingSessions'

const pages = [
  {
    path: '/coaching/sessions/upcoming',
    name: 'UPCOMING',
    defaultUrl: '/coaching/sessions',
  },
  {
    path: '/coaching/sessions/completed',
    name: 'COMPLETED',
  },
]

const SessionsTabbedView = ({
  location,
  showTabs,
  onCalendarViewChange,
  isCalendarView,
}) => {
  return (
    <div className='mt-3'>
      {showTabs && !isCalendarView && (
        <NavTabs
          pages={pages}
          pathname={location?.pathname}
          hash={location?.hash}
          NavLink={NavLink}
        />
      )}
      <Switch location={location}>
        <Route
          exact
          path={['/coaching/sessions', '/coaching/sessions/upcoming']}>
          <UpcomingSessions onCalendarViewChange={onCalendarViewChange} />
        </Route>
        <Route exact path='/coaching/sessions/completed'>
          <CompletedSessions />
        </Route>
      </Switch>
    </div>
  )
}

export default SessionsTabbedView
